import React from "react";
import { createMuiTheme, ThemeProvider, withStyles } from "@material-ui/core/styles";
require('typeface-open-sans');
require('typeface-montserrat');

const Theme = ({ children }) => {

    const styles = children.props.styles

    const theme = createMuiTheme({
        typography: {
            fontFamily: styles.fonts,
            fontSize: styles.body.fontSize,
            backgroundColor: styles.body.background
        },
        palette: {
            primary: { main: styles.colors.primary },
            secondary: { main: styles.colors.secondary },
            warning: { main: styles.colors.warning },
            white: { main: '#FFFFFF' },
            textColor: { main: styles.textColor },
            text: { primary: styles.textColor },
        },
        props: {
            MuiTable: {
                component: 'div'
            },
            MuiTableRow: {
                component: 'div'
            },
            MuiTableHead: {
                component: 'div'
            },
            MuiTableBody: {
                component: 'div'
            },
            MuiTableCell: {
                component: 'div'
            },
            MuiFormControl: {
                variant: 'outlined',
                fullWidth: true,
                size: 'small',
                align: 'left',
                margin: 'none'
            },
            MuiTextField: {
                margin: 'normal',
                size: 'small',
                variant: 'outlined',
                fullWidth: true
            },
            MuiFilledInput: {
                //margin: 'normal',
                size: 'small',
                variant: 'outlined',
                fullWidth: true,
            },
            MuiButton: {
                disableRipple: true,
                color: 'secondary',
                variant: 'contained'
            },
            MuiGrid: {
                alignContent: 'center',
            }
        },
        overrides: {
            MuiButton: {
                root: { textTransform: 'none' },
                contained: { color: styles.colors.primary, backgroundColor: styles.colors.primary },
                containedPrimary: {
                    backgroundColor: styles.colors.accentColor,
                    "&:hover": { backgroundColor: styles.colors.accentColorHover }
                },
                outlined: { borderColor: styles.colors.primary }
            },
            MuiAvatar: {
                colorDefault: { backgroundColor: styles.colors.primary }
            },
            MuiTypography: {
                h1: { color: styles.colors.primary, fontFamily: styles.fontsHeadings, fontSize: 48, letterSpacing: "-1px" },
                h2: { color: styles.colors.primary, fontFamily: styles.fontsHeadings, fontSize: 40, letterSpacing: "-1px" },
                h3: { color: styles.colors.primary, fontFamily: styles.fontsHeadings, fontSize: 32, letterSpacing: "-1px" },
                h4: { color: styles.colors.primary, fontFamily: styles.fontsHeadings, fontSize: 24, letterSpacing: "-1px" },
                h5: { color: styles.colors.primary, fontFamily: styles.fontsHeadings, fontSize: 16, letterSpacing: "-0.5px", fontWeight: 500 },
                h6: { color: styles.colors.primary, fontFamily: styles.fontsHeadings, fontSize: 8, letterSpacing: "-0.5px" },
            },
            MuiPaper: { rounded: { borderRadius: '12px' } },
            MuiTableCell: {
                root: { padding: '12px' },
                head: { fontWeight: 600, }
            },
            MuiListItemIcon: {
                root: { minWidth: 40 }
            }
        }
    });

    const drawerWidth = 265;

    const GlobalCSS = withStyles({
        "@global": {
            "body": {
                margin: 0,
                padding: 0,
                backgroundColor: styles.body.background,
                color: styles.body.color,

                "& > .sortable-item": {
                    boxShadow: "0px 0px 5px 0px gray",
                    display: "flex"
                }
            },

            ".floatedInputErrorText": {
                "& .MuiFormHelperText-root.MuiFormHelperText-contained": {
                    position: 'absolute',
                    bottom: '-10px',
                }
            },
            ".Select-SimpleSelect": {
                "& .MuiPaper-root": {
                    maxHeight: 5,
                }
            },
            ".showChipMode": {
                padding: 10,
                "& .MuiChip-deletable": {
                    margin: 3,
                }
            },
            ".cobranzasStatusMessage": {
                borderRadius: 5,
                fontSize: 13,
            },
            ".autocompleteComponent": {
                "&.disableAutocompleteInput": {
                    "& .MuiOutlinedInput-root": {
                        backgroundColor: '#ebebeb',
                        opacity: '0.5',
                    }
                }
            },
            ".containerOfficesSelection": {
                padding: 15,
                marginTop: 15,
                marginBottom: 15,
                border: '1px solid #d9e1ed',
                borderRadius: 5,
                "& .chipsContainer": {
                    padding: 20,
                    width: '100%',
                    "& .chip": {
                        margin: theme.spacing(0.5),
                    },
                    "& .chips": {
                        "& .MuiChip-root": {
                            margin: '1px 3px'
                        },
                        "&.filled": {
                            flexGrow: 1
                        },
                    },
                },
                "&.disableContainerOfficesSelection": {
                    backgroundColor: '#efefef',
                    border: '2px solid #d1d1d1',
                    opacity: '0.8',
                    pointerEvents: 'none',
                    "& .containerRadioGroup": {
                        opacity: '0.8',
                    },
                    "& .title": {
                        color: '#b3b3b3',
                    },
                },
                "& .showCardData": {
                    "& .title": {
                        color: '#161616',
                    },
                    "& .text": {
                        color: '#161616',
                    },
                    "& .chips": {
                        "& .MuiChip-root.Mui-disabled": {
                            color: '#161616',
                            opacity: '0.8',
                            border: '1px solid grey',
                            margin: 5,
                        },
                        "&.filled": {
                            color: '#161616',
                        },
                        "& .MuiChip-label": {
                            color: '#161616',
                        },
                    },
                },
            },
            ".containerCountryAmountSelection": {
                padding: 15,
                marginTop: 15,
                marginBottom: 15,
                border: '1px solid #d9e1ed',
                borderRadius: 5,
                "& .containerCountryAmountButton": {
                    margin: 0,
                    padding: 10,
                    borderRadius: 5,
                    backgroundColor: '#ffffff',
                    position: 'relative',
                    top: '-27px',
                    border: '1px solid #1751a1',
                    textAlign: 'center',
                },
                "& .containerButtonOficinasExcluidas": {
                    textAlign: 'right',
                },
                "& .containerRadioGroup": {
                    "& .MuiFormGroup-root": {
                        "& .MuiFormControlLabel-label": {
                            fontSize: 14,
                        },
                    },
                },
                "& .inputLabelTooltipGrid": {
                    paddingTop: 20,
                    "& .MuiFormControl-root.MuiTextField-root": {
                        paddingTop: 0,
                        marginTop: 3
                    },
                    "& .inputLabelTooltip": {
                        display: 'flex',
                        marginBottom: 10,
                        "& .title": {
                            fontSize: 14,
                        },
                        "& .tooltipInput": {
                            marginLeft: 10,
                            opacity: "0.8",
                            fontSize: 17,
                            color: '#8b8b8b',
                        },
                    },
                },
                "& .containerSelectCountry": {
                    "& .disableSelectCountry": {
                        backgroundColor: '#e9e9e9',
                    },
                    "& .selectMultipleChips": {
                        // padding: 0,
                        "& .selectInput": {
                            // border: '1px solid #dbdbdb',
                            minHeight: 40,
                            borderRadius: 3,
                        },
                        "&.formControl": {
                            margin: 10,
                            minWidth: 120,
                            maxWidth: 300,
                        },
                        "& .title": {
                            fontSize: 14,
                            marginBottom: 5,
                        },
                        "&.disabled": {
                            "& .title": {
                                color: '#b3b3b3',
                                fontSize: 14,
                            },
                        },
                        "& .chips": {
                            display: 'flex',
                            flexWrap: 'wrap',
                        },
                        "& .chip": {
                            margin: 2,
                        },
                        "& .noLabel": {
                            marginTop: 3,

                        },
                    },
                    "& .contMessage": {
                        "& .message": {
                            textAlign: 'center',
                            marginTop: 5,
                            "& .explain": {
                                color: '#FF9800',
                                fontWeight: 600,
                            },

                        },
                        "& .instructions": {
                            marginTop: 5,
                            fontSize: 12,
                            color: '#9d9d9d',
                            fontStyle: 'italic',

                        },
                    },
                },
                "&.disableCountryAmount": {
                    backgroundColor: '#efefef',
                    border: '2px solid #d1d1d1',
                    "& .containerRadioGroup": {
                        opacity: '0.8',
                    },
                    "& .inputLabelTooltipGrid": {
                        opacity: '0.8',
                    },
                    "& .selectMultipleChips": {
                        opacity: '0.8',
                    },
                    "& .bloqTitleContainer": {
                        opacity: '0.8',
                        "& .title": {
                            color: 'grey',
                        },
                    },
                },
                "&.disableInitialCountryAmount": {
                    backgroundColor: '#efefef',
                    border: '2px solid #d1d1d1',
                    opacity: '0.8',
                    pointerEvents: 'none',
                },
            },
            ".filterRateContainer": {
                border: '1px solid',
                borderColor: '#1751a1',
                borderRadius: 5,
                backgroundColor: '#1751a10f',
                padding: '5px 10px',
                marginBottom: 10,
                "& .filterButton": {
                    marginTop: 10,
                },
                "& .MuiInputLabel-formControl": {
                    top: 9,
                    fontSize: '12px !important',

                },
            },
            ".filterRateShowAll": {
                border: '1px solid',
                borderColor: '#1751a1',
                backgroundColor: '#1751a10f',
                padding: 0,
                textAlign: 'center',
                marginBottom: 10,
                "& .textInfo": {
                    fontSize: 14,
                    color: '#ff5722',
                },
                "& .textLink": {
                    fontSize: 12,
                    color: '#03a9f4',
                    fontStyle: 'italic',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                }
            },
            ".showFilterButton": {
                float: 'right',
                // position: 'absolute',
                // right: 50,
                // bottom: 100,
            },
            ".rateCode": {
                opacity: '1',
                paddingTop: '8px !important',
                "&.hide": {
                    opacity: '0.6',
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: 'none'
                    },
                },
            },
            ".containerMessageProductCode": {
                border: '1px solid orange',
                // position: 'absolute',
                // right: 50,
                // bottom: 100,
            },
            ".Select-MultipleSelect": {
                "& .MuiInputLabel-outlined": {
                    transform: 'translate(14px, 42px) scale(1);'
                },
                "&.SelectSmall": {
                    "& .MuiInputLabel-outlined": {
                        transform: 'translate(14px, 34px) scale(1);'
                    },
                },
                "&.MuiInput-underline:before": {
                    border: 'none'
                },
                "&.MuiInput-underline:hover:not(.Mui-disabled):before": {
                    border: 'none'
                },
                "& .MuiPaper-root": {
                    maxHeight: '340px',
                },
                "& .MuiSelect-selectMenu": {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                    border: '1px solid',
                    paddingLeft: '14px',
                    paddingTop: '18.5px',
                    paddingBottom: '18.5px'
                },
                "& .MuiInputLabel-shrink": {
                    transform: 'none'
                },
                "& .MuiInput-formControl": {
                    marginTop: 0
                }
            },
            ".SelectSmall": {
                "& .MuiSelect-selectMenu": {
                    paddingTop: 10.5,
                    paddingBottom: 10.5
                },
            },
            ".wrapper": { display: 'flex' },
            ".appBar": {
                zIndex: theme.zIndex.drawer + 1,/*
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }), */
            },
            ".appBarShift": {
                /* marginLeft: drawerWidth,
                width: `calc(100% - ${drawerWidth}px)`,
                transition: theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }), */
            },
            ".drawerPaper": {
                position: 'relative',
                whiteSpace: 'nowrap',
                width: drawerWidth,
                minHeight: '100vh',

                border: 'none',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),

                "& .collapsedItem": {
                    display: 'flex',
                    whiteSpace: 'pre-wrap'
                }
            },
            ".drawerPaperClose": {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                    width: 56,
                },
            },

            ".menuIsologo": {
                marginRight: 22,
                marginLeft: 8
            },

            ".menuIsologoHidden": {
                display: 'none',
            },
            '.LayoutContainer': {
                paddingTop: theme.spacing(4),
                paddingBottom: theme.spacing(4),
            },
            ".paperDrawer": {
                padding: theme.spacing(2),
                display: 'flex',
                overflow: 'auto',
                flexDirection: 'column',
            },
            ".app_bar_spacer": theme.mixins.toolbar,
            ".containerTAbleListItems": {
                "& .checkAllBoxes": {
                    marginLeft: 20,
                    "& .MuiFormControlLabel-label": {
                        fontSize: 12,
                    },
                },
                "& .modalTableListItems": {
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: 12,
                    "& th": {
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                        backgroundColor: '#1751a1de',
                        color: 'white'
                    },
                    "& th, & td": {
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "left",
                    },
                },
            },
            ".MainLayout_wrapper": {
                display: 'flex',
                "& .toolbar_Appbar": {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    padding: theme.spacing(0, 1),
                    // necessary for content to be below app bar
                    ...theme.mixins.toolbar,
                },
                "& .toolbarDrawer": {
                    //backgroundColor: 'red',
                    //display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    //padding: '0 8px',
                    //maxHeight: '64px',
                    ...theme.mixins.toolbar,
                },
                "& .toolbarDrawerSidebar": {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    padding: '0 8px',
                    ...theme.mixins.toolbar,
                },
                "& .toolbarDrawerButton": {
                    color: styles.colors.primary,
                    position: 'absolute',
                    top: 72,
                    right: -25,
                    backgroundColor: styles.body.background,
                    padding: 10,
                    "& .MuiIconButton-label": {
                        position: "relative", left: "-6px"
                    }

                },
                "& .toolbarLink": {
                    display: "flex",
                    marginRight: "auto",
                    alignItems: "center",
                    height: "100%",

                    "& .toolbarLogo": {
                        maxHeight: 35,
                        marginLeft: 10,
                    },
                },
                "& .main_admin": {
                    flexGrow: 1,
                    overflow: 'auto',

                    "& .MuiGrid-align-content-xs-center": {
                        alignContent: "stretch",
                    }
                },
                "& .title_Dashboard": {
                    marginLeft: 16,
                    color: 'white'
                }
            },
            ".bloqInputsConciliationResumeTransactions": {
                position: 'relative',
                "& .inputTooltip": {
                    position: 'absolute',
                    right: 4,
                    top: 0,
                    opacity: '0.5'
                }
            }
            ,
            ".bloqProductUpFile": {
                display: "flex",
                paddingTop: "0px !important",

                "& .input": {
                    display: "none"
                },

                "& .MuiButton-root": {
                    marginTop: 22
                },
                "& .divButton": {
                    flexGrow: 1,
                },
                "& .bloqFileName": {
                    flexGrow: 4,
                    "& .MuiInputBase-root.Mui-disabled": {
                        backgroundColor: "rgba(0, 0, 0, 0.05)"
                    }
                },
                "& .bloqComission": {
                    flexGrow: 4,
                    "& .MuiInputBase-root.Mui-disabled": {
                        backgroundColor: "rgba(0, 0, 0, 0.05)"
                    }
                },
            },
            ".list_config": {
                "& .card_item": {
                    marginBottom: "20px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.12)",
                    transition: "box-shadow 0.3s ease-in-out",
                    "& .step_payment_title": {
                        color: "#12171d",
                    }
                },
            },
            ".modalConciliationUpFile": {
                "& .inputDiv": {
                    fontSize: 16,
                    padding: 0,
                    margin: 0
                },
                "& .selectSwitch.MuiFormControl-root": {
                    "& .MuiFormLabel-root": {
                        color: styles.colors.primary,
                        fontSize: 14,
                    },
                },
                "& .selectPeriodo": {
                    display: "inline-block",
                    marginTop: 5,
                    "& .MuiSelect-outlined.MuiSelect-outlined": {
                        paddingRight: 0,
                    },
                    "& .MuiFormLabel-root.MuiInputLabel-shrink": {
                        color: styles.colors.primary,
                    },
                    "& .selectDiv": {
                        display: "inline-block",
                        "&.month": {
                            width: "60%",
                        },
                        "&.year": {
                            width: "40%",
                        },
                        "& .MuiInputBase-root": {
                            display: "inline"
                        },
                    },
                    "& .errorMessage": {
                        color: "#d14242",
                        fontSize: 11,
                        marginTop: 5,
                    },
                },
                "& .bloqConciliationUpFile": {
                    display: "flex",
                    "& .errorMessage": {
                        color: "#d14242",
                        fontSize: 11,
                    },
                    "& .input": {
                        display: "none"
                    },
                    "& .MuiFormControl-root": {
                        paddingTop: 10,
                        paddingBottom: 0,
                        marginBottom: 5,
                    },

                    "& .MuiButton-root": {
                        marginTop: 26,
                        height: 40,
                        marginRight: 5,
                    },
                    "& .divButton": {
                        display: "inline-block"
                    },
                    "& .bloqFileName": {
                        display: "inline-block",
                        "& .MuiFormLabel-root": {
                            marginTop: -10,
                            color: styles.colors.primary,
                        },
                        "& .MuiInputBase-root.Mui-disabled": {
                            backgroundColor: "rgba(0, 0, 0, 0.05)"
                        }
                    },
                    "& .bloqComission": {
                        display: "inline-block",
                        "& .inputComission": {
                            border: '1px solid red',
                            paddingTop: 4,
                        },
                        "& .MuiFormLabel-root": {
                            marginTop: -10,
                            color: styles.colors.primary,
                        },
                        "& .MuiInputBase-root.Mui-disabled": {
                            backgroundColor: "rgba(0, 0, 0, 0.05)"
                        }
                    },
                },

            },
            ".main": { flexGrow: 1, height: '100vh', overflow: 'auto' },
            ".inputTextWarning": {
                color: '#607d8b',
                position: 'relative',
                top: '-10px',
                fontSize: '12px',
            },
            ".inputDisabledGrey": {
                "& .MuiInputBase-root.Mui-disabled": {
                    backgroundColor: "#e9e9e970"
                },
            },
            ".login": {
                backgroundColor: 'white',
                textAlign: 'left',

                /* "& .form":{
                    width: '80%'
                }, */
                /* "& .submit":{
                    margin: theme.spacing(3, 0, 2),
                }, */
                "& .title": {
                    //marginBottom: theme.spacing(1),
                    marginBottom: 0,
                },
                /* "& .subtitle": {
                    marginBottom: theme.spacing(4),
                }, */
                "& .form-header": {
                    marginBottom: theme.spacing(4),
                }
            },
            ".login_container": {
                padding: theme.spacing(3),
                display: "flex",
                flexDirection: 'column',

                "& .logo": {
                    width: "80%",
                    maxWidth: 350,
                    alignSelf: 'center',
                    marginBottom: theme.spacing(6)
                }
            },
            ".headerLogoText": {
                textAlign: "left"
            },
            ".main.login": {
                "& .MuiGrid-align-content-xs-center": {
                    alignContent: "stretch",
                }
            },
            ".bg-login": {
                backgroundColor: styles.colors.primary,
                backgroundPosition: 'center',
                backgroundSize: "cover",
                "& .logo": { display: "block", position: "relative", top: "80px", maxWidth: "250px" }
            },
            ".paper": {
                padding: theme.spacing(2),
                display: 'flex',
                flexDirection: 'column',
            },
            ".container": {
                paddingTop: theme.spacing(4),
                paddingBottom: theme.spacing(4),
            },
            ".mainLayout_container": {
                paddingTop: theme.spacing(2.5),

                "& > .MuiGrid-container": {
                    "& > .MuiGrid-item": {
                        width: '100%'
                    }
                }
            },
            ".content_section": {
                backgroundColor: 'rgba(255,255,255,.5)'
            },
            ".filters": {
                "& .MuiFormControl-root": {
                    marginRight: 8
                }
            },
            ".filters_section_container": {
                display: 'flex',
                alignItems: 'center',
                marginBottom: theme.spacing(3),
                padding: 0
            },
            ".filters_section_left": { flexGrow: 1, },
            ".filters_section_actions": {
                marginRight: 0
            },
            ".filter_tablecell": {
                "& .MuiFormControl-root": {
                    paddingTop: 0,
                    marginBottom: 0
                },
                "& .MuiFormLabel-root": {
                    display: 'none'
                }
            },
            ".header_section_container": {
                paddingTop: theme.spacing(3),
                paddingBottom: theme.spacing(0),
            },
            ".header_detail_dashboard": {
                display: 'flex',
                alignItems: 'start',
                marginBottom: theme.spacing(3),
                padding: 0,
            },
            ".header_detail_dashboard_avatar_title": {
                flexGrow: 1,
            },
            ".header_detail_dashboard_actions": {

            },
            ".header_detail_dashboard_avatar": {
                flex: "0 0 auto", marginRight: 16
            },
            ".header_detail_dashboard_title": {
                flex: "1 1 auto",
                "& .section": {
                    textTransform: 'uppercase',
                    color: styles.textColor,
                    display: 'block',
                    fontSize: 14,
                    fontWeight: 600
                },
                "& .title": {
                    fontSize: 22,
                    fontWeight: 500
                }
            },

            ".content_detail_dashboard": {
                "& > .MuiGrid-container": {
                    alignItems: 'flex-start',
                    "& > .MuiGrid-item": {
                        maxWidth: "100%"
                    }
                },

                "& .MuiTabs-scroller": {
                    overflowX: 'auto !important'
                },

                "& *::-webkit-scrollbar": {
                    display: "none"
                }
            },
            ".content-center": {
                display: 'flex',
                flexDirection: 'column',
            },
            ".MuiFormControl-root": {
                textAlign: 'left',
                paddingTop: 22,
                marginBottom: 12,
                paddingBottom: 10,
                //sin overflow por los mensajes de validación
                [theme.breakpoints.down('sm')]: { marginBottom: 12 },
                "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                    color: styles.inputsLabelColor,
                    transform: "none",
                    whiteSpace: "nowrap",
                    fontSize: styles.inputsLabelFontSize,
                    fontWeight: styles.inputsLabelFontWeight,
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    width: "100%",
                },
                "& fieldset": {
                    top: 0,
                    "& legend": { display: "none" },
                },
                "&.form_passw": {
                    marginBottom: 5,
                    paddingBottom: 0,
                },
            },
            ".card_button": { marginRight: 8 },
            ".button_white_outlined.MuiButton-outlined": { borderColor: 'white', color: 'white' },
            ".detail_dashboard": {

            },
            ".BreadcrumbsDashboard": {
                display: 'flex',
                width: '100%',
                marginBottom: 0,
                //fontSize: 14,
                //"& .text":{ fontSize: 14 }
                "& a ": { color: styles.textColor },
                "& a:hover ": { color: styles.linkColorHover }
            },
            ".tabTitle": {
                "& .MuiTab-wrapper": {
                    flexDirection: 'row',
                    "& span": { display: 'inline-block' },
                    "& .MuiIcon-root": { marginRight: 10 }
                }

            },
            ".toolbarTab": {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(1),
                display: 'flex',

                "& .toolbarTab_buttons": {
                    marginRight: 0
                }
            },
            ".toolbar_tab_title": {
                flexGrow: 1,
                textTransform: 'uppercase'
            },
            ".tableList": {
                width: '100%',
                marginBottom: theme.spacing(2),
                "& .tableList_table": {
                    minWidth: 750,
                    "& .MuiTableRow-root": {
                        "& .MuiTableCell-root:firts-child": {
                            width: '40%'
                        },

                    }
                },
                "& .filterAdvanceInputs": {
                    paddingRight: 90
                }
            },
            ".tableMaterialPromo": {
                width: "100%",
                borderCollapse: "collapse"
            },
            ".tableMaterialPromo th, .tableMaterialPromo td": {
                border: "1px solid #ddd",
                padding: "8px",
                textAlign: "left"
            },
            ".visuallyHidden": {
                border: 0,
                clip: 'rect(0 0 0 0)',
                height: 1,
                margin: -1,
                overflow: 'hidden',
                padding: 0,
                position: 'absolute',
                top: 20,
                width: 1,
            },
            ".container_chips": {
                display: 'flex',
                justifyContent: 'start',
                flexWrap: 'wrap',
                '& > *': {
                    margin: theme.spacing(0.5),
                }
            },
            ".chips_roles": {
                "& .MuiChip-label": {
                    fontSize: 11
                }
            },
            ".buttons_actions": {
                '& > *': {
                    marginLeft: theme.spacing(0.5),
                    marginRight: theme.spacing(0.5),
                }
            },
            ".MenuHeader_Avatar": {
                color: '#FFFFFF',
                backgroundColor: 'rgba(255,255,255,.2)',
                overflow: 'visible'
            },
            ".MenuHeader_Badge": {
                "& .MuiBadge-badge": { backgroundColor: 'orange' }

            },
            ".button_lowecase": {
                "& .MuiTypography-root": { textTransform: 'none' }
            },
            ".MenuLogin": {
                display: 'flex'
            },
            ".cardActionsButtons": {
                marginBottom: 15,
                backgroundColor: '#19519e05',
                borderBottom: '2px solid #19519e',
                paddingBottom: 5,
                borderTop: '1px solid #19519e',
                top: '-25',
                position: 'relative',
                "& .titleActions": {
                    width: '100%',
                    color: '#19519e',
                    marginLeft: 10,
                    marginTop: 5,
                },
            },
            ".Detail_Action_ViewHeader": {
                backgroundColor: '#f5f5f5',
                flexWrap: "wrap",

                "& .MuiCardHeader-action": {
                    display: "flex",
                    flexWrap: "wrap",
                    maxWidth: "100%",
                    alignItems: "center"
                },
                "& .headerCardButtons": {
                    display: 'flex',
                    justifyContent: "space-between"
                }
            },
            ".Detail_Action_ViewContainer": {
                margin: 20,
                padding: theme.spacing(2),
            },
            ".DashboardCardContracted": {
                "& .MuiCardHeader-action": { margin: 0 },
                "& .icon": {
                    padding: 8,
                    display: 'block',
                    width: 40,
                    height: 40,
                    borderRadius: '50%'
                },
                "&:hover": {
                    "& .icon": {
                        backgroundColor: '#f0f0f0',
                    }
                }
            },
            ".chipLastLogin": {
                float: 'right'
            },
            ".voucher-detail": {
                "& .MuiBox-root": {
                    padding: "0 12px"
                }
            },
            ".dialogTitle_root": { margin: 0, padding: theme.spacing(2) },
            ".dialogTitle_closeButton": { position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: theme.palette.grey[500] },
            ".dialogActions_root": { margin: 0, padding: theme.spacing(1) },
            ".dialogContent_root": { padding: theme.spacing(2) },
            ".buttonDelete": {
                backgroundColor: '#ec4139',
                color: '#fff',
                margin: '8px',
                "&:hover": {
                    backgroundColor: '#ff3b31'
                }
            },
            ".buttonDuplication": {
                margin: '8px',
            },
            ".dashboardCardTabs-root": {
                flexGrow: 1, width: '100%'
            },
            ".sidebarnav-back": {
                height: 54,
                display: 'flex',
                justifyContent: 'end'
            },
            ".sidebarnav-list": {
                width: '100%',
                maxWidth: 380,
                backgroundColor: theme.palette.background.paper,
                "& .MuiListItemText-primary": {
                    fontSize: '14px',
                    paddingRight: '20px'
                },
                "& .MuiListItemIcon-root": {
                    minWidth: '32px'
                },
                "& .MuiCollapse-wrapperInner": {
                    backgroundColor: '#f5f5f5'
                }
            },
            ".nested": {
                "& .MuiListItemText-primary": {
                    fontSize: '0.75rem',
                },
                "& .MuiListItem-root": {
                    paddingLeft: theme.spacing(3.5),
                },
                "& .nested": {
                    "& .MuiListItem-root": {
                        paddingLeft: theme.spacing(4.5),
                    }
                }
            },
            ".tabPanel_content": {
                padding: theme.spacing(2),
                minHeight: 400
            },
            ".cardView_container": {
                marginLeft: 0
            },
            ".large": {
                width: theme.spacing(7),
                height: theme.spacing(7),
            },
            ".MuiCardHeader-title": {
                fontSize: 16
            },
            ".toolbarTab_title ": {
                fontSize: 16
            },
            ".avatar_square": {

            },
            ".gridContainer": {
                "&.hidden": {
                    display: 'none',
                },
            },
            ".btnJoinOptions": {
                "&.MuiButton-outlinedPrimary": {
                    color: '#75ab35',
                    borderColor: '#8BC34A',
                    "&.selected": {
                        backgroundColor: '#f3f9ee',
                    },
                },
            },
            ".jointOptionsContainer": {
                border: "1px solid #8BC34A",
                borderRadius: 5,
                backgroundColor: "#8bc34a1a",
                padding: 5,
                marginBottom: 50,
                "& .relativeElement": {
                    position: 'relative',
                    padding: 0,
                    "& .absoluteElement": {
                        position: 'absolute',
                        top: '-25px',
                        left: '0px',
                        color: '#8BC34A',
                        fontWeight: 600,
                    },
                },
                "& .autocompletedContainer": {
                    "& .MuiInputBase-root": {
                        backgroundColor: "white",
                    },
                    "& .MuiChip-root": {
                        height: 20
                    },
                },
                "& .MuiFormLabel-root.MuiInputLabel-shrink": {
                    color: "#19519e"
                },
                "& .MuiInputBase-input": {
                    backgroundColor: "white",
                    "&.Mui-disabled": {
                        backgroundColor: "#dfdfdf",
                        cursor: "not-allowed"
                    },
                },
                "& .filterWordsContainer": {
                    "&.disable": {
                        opacity: 0.6,
                    },
                },
                "& .joinButtonContainer": {
                    display: 'flex',
                    "& .generateButton": {
                        marginTop: 22,
                        height: 40,
                    },
                    "& .downloadButton": {
                        marginTop: 22,
                        height: 40,
                        marginRight: 10
                    },
                },
            },
            ".filterContainer": {
                border: "1px solid #9d9d9d",
                borderRadius: 5,
                backgroundColor: "#f9f9f9",
                padding: 5,
                marginBottom: 15,
                "& .relativeElement": {
                    position: 'relative',
                    padding: 0,
                    "& .absoluteElement": {
                        position: 'absolute',
                        top: '-25px',
                        left: '0px',
                        color: '#9d9d9d',
                        fontWeight: 600,
                    },
                },
                "& .MuiFormLabel-root.MuiInputLabel-shrink": {
                    color: "#19519e"
                },
                "& .MuiInputBase-input": {
                    backgroundColor: "white",
                    "&.Mui-disabled": {
                        backgroundColor: "#dfdfdf",
                        cursor: "not-allowed"
                    },
                },
                "& .filterWordsContainer": {
                    "&.disable": {
                        opacity: 0.6,
                    },
                },
                "& .filterButtonContainer": {
                    "& .filterButton": {
                        marginTop: 22,
                        height: 40,
                    },
                },
            },
            ".conciliationCreateMessage": {
                textAlign: "center",
                "& div": {
                    margin: 15
                },
            },
            ".containerMainActions": {
                textAlign: "right",
                "& .MuiButtonBase-root": {
                    margin: 5
                },
            },
            ".floatPanel": {
                zIndex: 100,
                backgroundColor: "#f5f5f5",
                border: "2px solid #1751a1",
                position: "fixed",
                display: "flex",
                bottom: 20,
                right: 15,
                padding: 5,
                borderRadius: 10,
                // boxShadow: "2px 3px #00000021",
                "& .cell": {
                    fontSize: 12,
                    flexGrow: 1,
                    padding: 7,
                    "& .amount": {
                        fontSize: 14,
                        fontWeight: 600
                    },
                },
                "& .MuiButtonBase-root": {
                    marginTop: 6
                },
            },
            ".conciliationComments": {
                width: "100%",
                padding: 5,
                fontSize: 12,
                border: "1px solid #1751a1",
                borderRadius: 5,
                margin: "10px 0",
                "& .commentsLoading": {
                    padding: '20px 10px'
                },
                "& .commentsInputError": {
                    color: 'red',
                    marginLeft: 15
                },
                "& .bloqCommentInput": {
                    "& .MuiFormControl-root": {
                        paddingTop: 0,
                        paddingRight: 20
                    },
                    "& .MuiFormLabel-root": {
                        fontSize: 16
                    },
                    "& .commentsInputTitle": {
                        fontSize: 16,
                        marginTop: 15
                    },
                },
                "& .bloqCommentsLabels": {
                    "& .messageNoComments": {
                        padding: 15,
                        fontSize: 15,
                        textAlign: 'center',
                        color: '#d57f00',
                        marginTop: 20,

                    },
                    "& .listHeader": {
                        paddingTop: 0,
                        paddingRight: 20,
                        "& .MuiListItemText-root": {
                            overflow: 'auto',
                        },
                    },
                },
            },
            ".voucherComments": {
                width: "100%",
                padding: 5,
                fontSize: 12,
                margin: "10px 0",
                "& .commentsLoading": {
                    padding: '20px 10px'
                },
                "& .commentsInputError": {
                    color: 'red',
                    marginLeft: 15
                },
                "& .bloqCommentInput": {
                    alignContent: 'start',
                    "& .MuiFormControl-root": {
                        paddingTop: 0,
                        paddingRight: 20
                    },
                    "& .MuiFormLabel-root": {
                        fontSize: 16
                    },
                    "& .commentsInputTitle": {
                        fontSize: 16,
                        marginTop: 15
                    },
                },
                "& .bloqCommentsLabels": {
                    "& .messageNoComments": {
                        padding: 15,
                        fontSize: 15,
                        textAlign: 'center',
                        color: '#d57f00',
                        marginTop: 20,

                    },
                    "& .listHeader": {
                        paddingTop: 0,
                        paddingRight: 20,
                        "& .MuiListItemText-root": {
                            overflow: 'auto',
                        },
                    },
                },
            },
            ".conciliationTable": {
                width: "100%",
                padding: 5,
                fontSize: 12,
                border: "1px solid #1751a1",
                borderRadius: 5,
                backgroundColor: 'white',
                "& .rowCheckboxAll": {
                    "& .bank, & .sperta": {
                        border: "none",
                        textAlign: "left",
                        "& .MuiTypography-root": {
                            fontSize: 12
                        },
                    },
                    "& .cell.none": {
                        border: "none",
                    },
                    "& .bloqTotalAmount": {
                        display: "flex",
                        justifyContent: "space-between",
                        "& .totalAmount": {
                            paddingTop: 15,
                            fontSize: 13,
                            color: styles.colors.primary,
                        },
                    },
                },
                "& .rowHeaderTitle": {
                    color: "white",
                    "& .bank": {
                        backgroundColor: "#1751a1de",
                    },
                    "& .sperta": {
                        backgroundColor: "#a1a0a0",
                    },
                    "& .icon": {
                        color: "#a1a0a0 !important",

                    },
                },
                "& .rowHeaderSubTitle": {
                    fontWeight: 600,
                    "&.bank": {
                        border: "1px solid #1751a1",
                    },
                    "&.sperta": {
                        border: "2px solid #a1a0a0",
                    },
                },
                "& .rowHData": {
                    "& .cell.concilia": {
                        color: "#8bc34a",
                    },
                    "& .cell.No.concilia": {
                        color: "#ff9090",
                    },
                    "& .cell.manual": {
                        color: "#2196f3",
                    },
                    "& .cell.parcial, & .cell.Parcial": {
                        color: "orange",
                    },
                },
                "& .rowNoData": {
                    "& .cell": {
                        padding: 30,
                    },
                    background: "repeating-linear-gradient( 45deg, #f9f9f9, #f9f9f9 10px, #cbcbcb   10px, #cbcbcb   20px)",
                },
                "& .cell": {
                    padding: 5,
                    textAlign: "center",
                    border: "1px solid #ebebeb",
                    "&.bank": {
                        border: "1px solid #1751a1",
                    },
                    "&.sperta": {
                        border: "2px solid #a1a0a0",
                    },
                    "&.input": {
                        border: "2px solid #a1a0a0",
                    },
                },
                "& .cellIntercolumn": {
                    textAlign: "center",
                    backgroundColor: "#ebebeb",
                    "& .MuiIcon-root": {
                        fontSize: 20,
                        opacity: "0.8"
                    },
                },
            },
            ".conciliationTableSummary": {
                width: '100%',
                fontSize: 14,
                border: "1px solid #1751a1",
                borderRadius: 5,
                backgroundColor: 'white',
                "& .cell": {
                    whiteSpace: "nowrap",
                    padding: 5,
                    textAlign: "center",
                    border: "1px solid #ebebeb",
                    "&.bank": {
                        border: "1px solid #1751a1",
                    },
                    "&.sperta": {
                        border: "2px solid #a1a0a0",
                    },
                    "&.input": {
                        border: "2px solid #a1a0a0",
                    },
                },
            },
            ".dialogUploadFile": {
                backgroundColor: '#fff6f8',
                border: '2px solid pink',
                "& .conciliationTable": {
                    fontSize: 10,
                    "& .celdaSeparadoraBloques": {
                        borderBottom: '1px solid rgb(53 103 172 / 40%)',
                        padding: 0,
                        color: 'rgb(53 103 172 / 70%)'
                    },

                    "& .rowHeaderTitle": {
                        "& .bank, & .sperta": {
                            padding: 0
                        },
                    },
                    "& .cell": {
                        padding: 2,
                        border: 'none',
                        borderBottom: '1px solid #e3e3e3'
                    },
                },
                "& .buttonBloq": {
                    textAlign: 'right',
                    padding: 10,
                    "& .MuiButtonBase-root": {
                        marginRight: 5
                    },
                },
            },
            ".cardView_Tours": {
                //marginTop: '-30px!important',

                "& .icon_added": {
                    position: 'absolute',
                    backgroundColor: 'white',
                    //border: '2px solid white',
                    top: 0,
                    left: 0,
                    height: 24,
                    width: 24,
                    borderRadius: '50%',
                    boxShadow: "0 3px 5px 2px rgba(0, 0, 0, .3)",
                    textAlign: 'center',
                    color: 'green',
                    zIndex: 10

                },
                "& .tour": {
                    position: 'relative',
                    overflow: 'visible',
                    borderBottom: '1px solid #d2d2d2',
                    marginBottom: theme.spacing(1.5),
                    paddingBottom: theme.spacing(1),
                    borderRadius: 0
                },
                "& .title_card_tour": {
                    paddingRight: 100,
                    position: 'relative',
                    lineHeight: 1.2,
                    fontSize: 18,
                    "& .MuiChip-root": {
                        marginLeft: theme.spacing(1.5),
                        position: 'absolute',
                        right: 0,
                        top: 0
                    },
                },
                "& .col_title": {
                    //marginBottom: theme.spacing(1)
                },
                "& .collapse_content_container": {
                    paddingTop: theme.spacing(1.5),
                    "& .title": {
                        color: styles.headingsColor,
                        fontWeight: 600
                    }
                },
                "& .MuiListItem-root": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    alignItems: "start",
                    marginBottom: 8
                },
                "& .MuiListItemText-root": {
                    marginTop: 0,
                    marginBottom: 0
                },
                "& .MuiListItemSecondaryAction-root": {
                    top: 26,
                    right: 8
                },
                "& .listItemTour": {
                    "& .MuiAvatar-root": {
                        width: 45,
                        height: 45,
                    },
                    "& .MuiListItemText-primary": {
                        color: styles.headingsColor,
                        fontWeight: 600,
                        fontSize: 13,
                        letterSpacing: 'normal',
                        lineHeight: '1.2em',
                        marginBottom: theme.spacing(0.5)
                    },
                    "& .MuiListItemText-secondary": {
                        fontSize: 12,
                        letterSpacing: 'normal',
                        lineHeight: 1.2
                    },
                    "& .MuiListItemText-root ": {
                        borderBottom: '1px solid #d2d2d2',
                        paddingBottom: theme.spacing(1)
                    }

                },
                "& .tabPanel_content": {
                    padding: 0
                },

                "& .col_left": {
                    "& .MuiAvatar-root": {
                        width: 70,
                        height: 70
                    },
                    [theme.breakpoints.up('md')]: {
                        maxWidth: 80,
                        flexBasis: 80,
                    }
                },
                "& .col_center": {
                    [theme.breakpoints.up('md')]: {
                        maxWidth: 'calc(80% - 80px)',
                        flexBasis: 'calc(80% - 80px)',
                    }
                },
                "& .col_right": {
                    textAlign: 'right',
                    [theme.breakpoints.up('md')]: {
                        maxWidth: '20%',
                        flexBasis: '20%',
                    }
                },
                "& .MuiCardContent-root": {
                    padding: theme.spacing(1.5)
                },

                "& .MuiCardContent-root:last-child": {
                    padding: theme.spacing(1.5)
                },
            },
            ".collapse_link": {
                padding: 0,
                textDecoration: 'none',
                cursor: 'pointer',
                "&:hover": {
                    textDecoration: 'none',
                }
            },
            ".collapse": {
                "& .expand": {
                    transform: 'rotate(0deg)',
                    marginLeft: 'auto',
                    transition: theme.transitions.create('transform', {
                        duration: theme.transitions.duration.shortest,
                    }),
                },
                "& .expandOpen": {
                    transform: 'rotate(180deg)',
                },
            },
            ".MuiCardContent-root": {
                paddingBottom: theme.spacing(1.5)
            },
            ".MuiCardContent-root:last-child": {
                paddingBottom: theme.spacing(1.5)
            },
            ".MuiList-root": {
                "& .MuiListItem-container:last-child": {
                    "& .MuiListItem-root": {
                        marginBottom: 0
                    }
                }
            },
            ".rateAccordion": {
                "& .MuiAccordionSummary-root": {
                    minHeight: 10,
                    backgroundColor: "#f7f7f7",
                },
                "& .noRateSelected": {
                    display: 'flex',
                    margin: 'auto',
                    "& .text": {
                        justifyContent: 'center',
                        color: '#FF9800',
                        margin: 'auto'
                    },
                },
                "& .MuiAccordionSummary-content": {
                    margin: '5px 0px',
                },
                "& .MuiCollapse-container": {
                },
            },
            ".accordion_paper": {
                padding: theme.spacing(1.5),
                marginBottom: theme.spacing(1.5)
            },
            ".custom_accordion": {
                margin: 0,
                backgroundColor: 'transparent',
                padding: 0,
                boxShadow: 'none',
                "& .MuiAccordionSummary-root": {
                    paddingLeft: 0,
                },
                "& .MuiAccordionSummary-content": {
                    margin: 0
                },
                "& .MuiAccordionDetails-root": {
                    padding: 0,
                    display: 'block'
                },
                "& .MuiAccordionSummary-root.Mui-expanded": {
                    minHeight: 'inherit'
                }
            },
            ".filter_tours_chips": {
                boxShadow: 'none',
                display: 'flex',
                justifyContent: 'start',
                flexWrap: 'nowrap',
                listStyle: 'none',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 16,
                paddingRight: 16,
                margin: 0,
                borderRadius: theme.spacing(0.5),
                marginBottom: theme.spacing(0.5),
                border: "1px solid",
                borderColor: styles.colors.lightGrey,
                alignItems: "center",
                "& .chip": {
                    margin: theme.spacing(0.5),
                },
                "& .title_filters": {
                    padding: theme.spacing(1),
                    textTransform: 'uppercase',
                    fontSize: 14,
                    lineHeight: '26px'
                },
                "& .chips": {
                    "&.filled": {
                        flexGrow: 1
                    },
                },
                "& .autocomplete_container": {
                    flexGrow: 1,
                    minWidth: 250,
                    display: 'flex',

                    "& .MuiFormControl-root": {
                        padding: 0
                    }
                },
                "& .button_filter": {
                    padding: 4,
                },
                "& .MuiFormControl-root": {
                    marginBottom: 0,
                    paddingTop: 0
                },
                "& .MuiFormLabel-root": {
                    display: 'none'
                },
                "& .MuiInputBase-root": {
                    padding: theme.spacing(0.5)
                },
                "&.caseRatesModulo": {
                    margin: theme.spacing(0.5),
                },
            },
            ".filter_tours_chips_vertical": {
                marginBottom: 10,
                "& .title_filters": {
                    marginBottom: 5
                },
                "& .chips": {
                    marginBottom: 5,
                    "& .chip": {
                        margin: theme.spacing(0.5),
                    },
                },
                "& .MuiFormControl-root": {
                    paddingTop: 0,
                    marginBottom: 8,
                    "& .MuiInputLabel-root": {
                        display: 'none'
                    }
                },
                "& .button_filter": {
                    "& .MuiButton-root": {
                        marginLeft: "0px !important"
                    }
                }
            },
            /* Inicio Modulo Rates: Autocomplete */
            ".filter_rates_chips": {
                boxShadow: 'none',
                display: 'flex',
                justifyContent: 'start',
                flexWrap: 'nowrap',
                listStyle: 'none',
                paddingTop: 10,
                paddingBottom: 10,
                margin: 0,
                borderRadius: theme.spacing(0.5),
                marginBottom: theme.spacing(0.5),
                border: "1px solid",
                borderColor: styles.colors.lightGrey,
                alignItems: "center",
                "& .bloqTitle": {
                    fontSize: 14,
                    padding: '5px 10px',
                },
                "& .autocompleteContainer": {
                    // contenedor autocomplete
                    padding: 10,
                    display: 'flex',
                    "& .autocomplete_container": {
                        minWidth: 450,
                        display: 'flex',
                        "& .MuiFormControl-root": {
                            padding: 0
                        }
                    },
                    "& .button_filter": {
                        padding: 1,
                    },
                    "& .selectAll.MuiButton-outlined": {
                        "&.selected": {
                            backgroundColor: "#8bc34a14",
                            color: '#597d2f',
                            border: '1px solid #597d2f',
                            fontWeight: 600,
                            "&.MuiButton-outlinedPrimary": {
                                border: '1px solid #597d2f'
                            }
                        }
                    },
                },
                "& .chipsContainer": {
                    padding: 20,
                    width: '100%',
                    "& .chip": {
                        margin: theme.spacing(0.5),
                    },
                    "& .chips": {
                        "& .MuiChip-root": {
                            margin: '1px 3px'
                        },
                        "&.filled": {
                            flexGrow: 1
                        },
                    },
                },
                "& .MuiFormControl-root": {
                    marginBottom: 0,
                    paddingTop: 0
                },
                "& .MuiFormLabel-root": {
                    display: 'none'
                },
                "& .MuiInputBase-root": {
                    padding: theme.spacing(0.5)
                },
                "&.caseRatesModulo": {
                    margin: theme.spacing(0.5),
                },
            },
            ".filter_rates_chips_vertical": {
                marginBottom: 10,
                "& .bloqTitle": {
                    fontSize: 14,
                    padding: '5px 10px',
                },
                "& .autocompleteContainer": {
                    // contenedor autocomplete
                    padding: 10,
                    display: 'block',
                    "& .autocomplete_container": {
                        display: 'flex',
                        "& .MuiFormControl-root": {
                            padding: 0
                        }
                    },
                    "& .button_filter": {
                        marginTop: 15,
                        "& .MuiButtonBase-root": {
                            margin: '6px 10px',
                        },
                    },
                },
                "& .chipsContainer": {
                    padding: 20,
                    width: '100%',
                    "& .chip": {
                        margin: theme.spacing(0.5),
                    },
                    "& .chips": {
                        "& .MuiChip-root": {
                            margin: '1px 3px'
                        },
                        "&.filled": {
                            flexGrow: 1
                        },
                    },
                },
                "& .MuiFormControl-root": {
                    paddingTop: 0,
                    marginBottom: 8,
                    "& .MuiInputLabel-root": {
                        display: 'none'
                    }
                },
                "& .button_filter": {
                    "& .MuiButton-root": {
                        marginLeft: "0px !important"
                    }
                }
            },
            ".autocomplete_button": {
                display: 'flex',
                width: '100%',
                alignItems: 'center',

                "& .autocomplete_container": {
                    flexGrow: 1,
                    marginBottom: 9
                },
            },
            ".MuiCardHeader-root": {
                backgroundColor: "#f7f7f7"
            },
            ".tableFilter": {
                backgroundColor: styles.colors.utralightGrey,
                border: "2px solid",
                borderColor: styles.colors.primary,
                "& .MuiButtonBase-root": {
                    margin: 5
                },
                "& .tableFilterCelda": {
                    padding: "2px 10px"
                },
                "& .filterButtonLabel": {
                    fontSize: 15,
                    color: styles.colors.primary,
                    paddingLeft: 5
                },
            },
            ".bloqConciliationUpFile": {
                display: "flex",
                justifyContent: 'flex-start',
                "& .errorMessage": {
                    color: "#d14242",
                    fontSize: 11,
                },
                "& .input": {
                    display: "none"
                },
                "& .MuiFormControl-root": {
                    paddingTop: 10,
                    paddingBottom: 0,
                    marginBottom: 5,
                },

                "& .MuiButton-root": {
                    marginTop: 26,
                    height: 40,
                    marginRight: 5,
                },
                "& .divButton": {
                    display: "inline-block"
                },
                "& .bloqFileName": {
                    display: "inline-block",
                    "& .MuiFormLabel-root": {
                        marginTop: -10,
                        color: styles.colors.primary,
                    },
                    "& .MuiInputBase-root.Mui-disabled": {
                        backgroundColor: "rgba(0, 0, 0, 0.05)"
                    }
                },
                "& .bloqComission": {
                    display: "inline-block",
                    "& .inputComission": {
                        paddingTop: 4,
                        "& .MuiFormLabel-root": {
                            fontSize: 14,
                            marginTop: '-5px',
                            left: '-10px',
                        },
                    },
                    "& .MuiFormLabel-root": {
                        marginTop: -10,
                        color: styles.colors.primary,
                    },
                    "& .MuiInputBase-root.Mui-disabled": {
                        backgroundColor: "rgba(0, 0, 0, 0.05)"
                    }
                },
            },
            ".dialogEditTarifa": {
                "& .bloqTitle": {
                    display: "block",
                },
                // "& .MuiIconButton-root": {
                //     padding: 5,
                // },
                "& .bloqInputs ": {
                    "& .bloqInput": {
                        "& .textField ": {
                            marginTop: '0px !important',
                            paddingRight: '0px !important',
                        },
                    },
                },
                "& .datePickerFromTo": {
                    "& .bloqDatePicker": {
                        display: "flex",
                        alignItems: "flex-end",
                        "& .dateFrom": {
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-end",
                            "& .label": {
                                padding: 3,
                                marginBottom: 13,
                            },
                            "& .datepicker": {
                                padding: 3,
                                marginTop: 5
                            },
                        },
                        "& .dateTo": {
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-end",
                            "& .label": {
                                padding: 3,
                                marginBottom: 13,
                            },
                            "& .datepicker": {
                                padding: 3,
                                marginTop: 5
                            },
                        },
                    },
                    "& .textField": {
                        padding: 0
                    }
                },
                "& .contBloqDetalle": {
                    backgroundColor: "#fffae9",
                    border: "1px solid #1346a3",
                    borderRadius: 5,
                    margin: 15,
                    "& .MuiAccordionSummary-root": {
                        backgroundColor: "white",
                    },
                    "& .MuiAccordionSummary-root.Mui-expanded": {
                        backgroundColor: "#f3f3f3",
                    },
                    "& .bloqDetalleTarifa": {
                    },
                    "& .selectSwitch.MuiFormControl-root": {
                        "& .MuiFormLabel-root": {
                            color: styles.colors.primary,
                        },
                    },

                },
            },
            ".main_admin": {
                "& .MuiGrid-root": {
                },
                "& .MuiFormControl-root": {
                    margin: 0
                },
                "& .alertTopCardContent": {
                    marginBottom: 15,
                },
                "& .inlineModules": {
                    display: 'flex',
                    justifyContent: 'start',
                    flexWrap: 'wrap',
                    "& .bloqAutocomplete": {
                        flexGrow: 1,
                    },
                    "& .bloqButton": {
                        paddingTop: 23,
                        paddingLeft: 5,
                    },
                    "& .MuiFormControl-root": {
                    },
                },

                "& .bloqTabs": {
                    "& .MuiTabs-flexContainer": {
                        backgroundColor: styles.colors.utralightGrey
                    },
                    "& .MuiTab-root": {
                        backgroundColor: styles.colors.primary,

                    },
                    "& .MuiAppBar-root": {
                        boxShadow: "none",
                        borderBottom: "1px solid #1751a1"
                    },
                    "& .borderBox": {
                        border: "1px solid",
                        borderColor: styles.colors.primary
                    }
                },
                "& .bloqProductImage": {
                    border: "1px solid #e4e4e4",
                    borderRadius: 8,
                    "& .imageProduct": {
                        maxWidth: 150,
                        margin: "0 auto",
                        display: "flex",
                        padding: 15,
                    }
                },
                "& .inputWhithButton": {
                    display: "flex",

                    "& .bloqInput": {
                        flexGrow: 4,
                    },
                    "& .bloqButton": {
                        paddingLeft: 5,
                        flexGrow: 1,
                        marginTop: 21,
                        "& Button": {
                            width: "100%",
                            height: 40,
                        },
                    }
                },
                "& .bloqCheckboxList": {
                    width: "32%",
                    border: "2px solid #dedede",
                    padding: 0,
                    display: "inline-block",
                    verticalAlign: "top",
                    margin: 5,
                    "& .MuiListSubheader-root": {
                        backgroundColor: styles.colors.lightGrey,
                        fontWeight: 600,
                        paddingLeft: 10,
                        borderBottom: "2px solid #1751a1",
                    },
                    "& .MuiListItem-gutters": {
                        padding: "0px 10px 0px 25px",
                        borderBottom: styles.colors.lightGrey
                    },
                    "& .MuiListItem-gutters:first-child": {
                        backgroundColor: "#dedede"
                    },
                    "& .MuiListItemIcon-root": {
                        minWidth: "auto"
                    },
                },
                "& .datePickerFromTo": {
                    "& .bloqTitle": {
                        display: "block",
                    },
                    "& .bloqDatePicker": {
                        display: "flex",
                        alignItems: "flex-end",
                        "& .dateFrom": {
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-end",
                            "& .label": {
                                padding: 5
                            },
                            "& .datepicker": {
                                padding: 5,
                            },
                        },
                        "& .dateTo": {
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-end",
                            "& .label": {
                                padding: 5,
                            },
                            "& .datepicker": {
                                padding: 5,
                            },
                        },
                        "& .MuiFormControl-root": {
                            padding: 0,
                            margin: 0
                        }
                    }
                },
                "& .inputMaxMin": {
                    "& .bloqTitle": {
                        display: "block",
                    },
                    "& .bloqDatePicker": {
                        display: "flex",
                        alignItems: "flex-end",
                        "& .dateFrom": {
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-end",
                            "& .label": {
                                padding: 5,
                            },
                            "& .datepicker": {
                                padding: 5,
                            },
                        },
                        "& .dateTo": {
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-end",
                            "& .label": {
                                padding: 5,
                            },
                            "& .datepicker": {
                                padding: 5,
                            },

                        },
                        "& .MuiFormControl-root": {
                            padding: 0,
                            margin: 0
                        },
                    }
                },
                "& .MuiFormControl-root .MuiInputLabel-outlined.MuiInputLabel-shrink, & .formLabel": {
                    fontSize: 14,
                    // color: styles.colors.primary,
                    fontWeight: 500,
                    fontFamily: "Montserrat, serif"
                },
                "& .formGridItem": {
                    marginBottom: 20
                },
                "& .cardTableContainer": {
                    "& .tableMaterial": {
                        "& .MuiTableHead-root": {
                            "& .MuiTableCell-head": {
                                color: styles.colors.primary,

                            },
                        },
                        "& ..MuiTableRow-root": {
                            paddingTop: 0,
                        },
                        "& .MuiTableCell-root": {
                            padding: "8px 10px",
                        },
                        "&.smallTable": {
                            "& .row_email_contact": {
                                overflowWrap: "anywhere"
                            },

                            "& .MuiTableCell-root": {
                                padding: "8px 0 8px 6px",
                            }
                        },
                        "&.Tarifa, &.Ancillary": {
                            "& .tableFilter .MuiSwitch-switchBase": {
                                margin: 0
                            }
                        }
                    }
                },
                "& .filter_button_container": {
                    display: "flex",
                    justifyContent: "end",
                    marginBottom: 15
                },
                "& .tableListActionsButtons": {
                    "& .iconButton": {
                        margin: 3,
                        backgroundColor: styles.colors.utralightGrey,
                        "&:hover": {
                            backgroundColor: styles.colors.lightGrey
                        }
                    }
                },
                "& .tableListModule": {
                    "& .tableMaterial": {
                        "& .tableModuleOffices": {
                            "& .titleAndSubtitle": {
                                "& .cellTitle": {
                                    color: styles.colors.primary,
                                    fontWeight: "600",
                                    fontSize: 14,
                                },
                                "& .cellSubtitle": {
                                    fontSize: 10,
                                    textTransform: "uppercase"
                                },
                            },
                        }
                    }
                },
                "& .repeatInputsModule": {
                    border: "1px solid grey",
                    borderColor: styles.colors.lightGrey,
                    padding: "10px 15px",
                    "& .titulo": {
                        backgroundColor: styles.colors.utralightGrey,
                    },
                    "& .iconButton": {
                        margin: 3,
                        backgroundColor: styles.colors.utralightGrey,
                        "&:hover": {
                            backgroundColor: styles.colors.lightGrey
                        }
                    }
                },
                "& .subGrupoModulo": {
                    margin: 3,
                    "& .grupoTitulo": {
                        backgroundColor: styles.colors.primary,
                        color: "white",
                        padding: "5px 15px",
                        "& .titulo": {
                            color: "white",
                        },
                    },
                    "& .grupoCuerpo": {
                        border: "1px solid",
                        borderColor: styles.colors.lightGrey,
                        padding: 10,
                    },
                },
                "& .contentNotFound": {
                    textAlign: "center",
                    "& .image": {
                        width: 50,
                        height: 50,
                    },
                    "& .bigText": {
                        fontSize: 18,
                    },
                    "& .smallText": {
                        fontSize: 14,
                    },
                    "& .icon": {
                        fontSize: 18,
                    },
                },
                "& .tableDragDrop": {
                    width: "100%",
                    marginTop: 7,
                    "& .alignCenter": {
                        textAlign: "center"
                    },
                    "& .alignLeft": {
                        fontSize: 14,
                        paddingLeft: 15
                    },
                    "& thead": {
                        backgroundColor: styles.colors.primary,
                        color: "white",
                        "& th": {
                            fontWeight: 500,
                            textAlign: "left",
                            padding: 5
                        },
                    },
                    "& td": {
                        padding: 5
                    },
                    "& tr:nth-child(even)": {
                        backgroundColor: styles.colors.utralightGrey
                    },
                    "& .MuiFormControl-root": {
                        paddingTop: 0,
                    }
                },
                "& .MuiButton-root.optionSelected": {
                    backgroundColor: "green"
                }
            },
            // Nivel Superior Generico de Anidamiento
            ".bloqWhiteTabs": {
                "& .MuiTabs-flexContainer": {
                    borderBottom: "2px solid #1751a1"
                },
                "& .MuiTab-root": {
                    border: "1px solid",
                    borderColor: styles.colors.primary,
                    opacity: 1,
                    borderBottom: "none",
                },
                "& .MuiButtonBase-root": {
                    minHeight: 35
                },
                "& .MuiTabs-indicator": {
                    display: "none"
                },
                "& .MuiTab-root.Mui-selected": {
                    backgroundColor: styles.colors.primary,
                    "& .MuiTypography-root": {
                        color: "white"
                    }
                },
                "& .MuiAppBar-root": {
                    boxShadow: "none",
                    borderBottom: "1px solid #1751a1"
                },
                "& .borderBox": {
                    border: "1px solid",
                    borderColor: styles.colors.primary
                }
            },
            ".tableOptions": {
                width: "100%",
                borderColor: styles.colors.lightGrey,
                marginTop: 15,
                "& thead": {
                    backgroundColor: styles.colors.lightGrey,
                    // color: "white"
                },
                "& td": {
                    padding: 5,
                    textAlign: "center",
                },
                "& tr:nth-child(even)": {
                    backgroundColor: styles.colors.utralightGrey
                },
                "& .MuiFormControl-root": {
                    paddingTop: 0,
                },
                "& .buttonsColumn": {
                    paddingTop: 0,
                    "& .MuiButtonBase-root": {
                        minHeight: "auto",
                        marginRight: 5,
                        backgroundColor: styles.colors.utralightGrey,
                        "&:hover": {
                            backgroundColor: styles.colors.lightGrey
                        }
                    }
                }
            },
            "hr": {
                borderColor: styles.colors.utralightGrey,
            },
            ".subBloqueBorder": {
                border: "1px solid",
                borderColor: styles.colors.lightGrey,
            },
            ".chipsContainer": {
                "& .MuiChip-root": {
                    marginRight: 10,
                    padding: 5,
                }
            },
            ".MuiSwitch-root": {
                "& .MuiSwitch-colorPrimary.Mui-disabled.Mui-checked": {
                    color: styles.colors.primary,
                    opacity: 0.7,
                }
            },
            ".datepicker": {
                "& .MuiOutlinedInput-adornedStart": {
                    paddingLeft: 0,
                }
            },
            ".collapsibleCard": {
                marginBottom: 15,
                backgroundColor: styles.colors.primary,
                borderRadius: 10,
                "& .MuiAccordionSummary-root.Mui-expanded": {
                    minHeight: 47,
                },
                "& .MuiIconButton-root": {
                    padding: "5px 15px",
                },
                "& .MuiAccordionSummary-root": {
                    color: "white",
                    padding: "5px 15px",
                    "& .MuiAccordionSummary-content": {
                        color: "white",
                        margin: "5px 0px",
                    },
                    "& .MuiIconButton-label": {
                        color: "white",
                    },
                },
            },
            ".botonIconGeneric": {
                height: 40,
                marginTop: 21,
                boxShadow: 'none',
                textAlign: 'center'
            },
            ".paginationBlock": {
                "& .buttonExport": {
                    display: 'inline-flex',
                    float: 'left',
                    margin: '15px 0 15px 12px'
                },
                "& .pagination": {
                    display: 'inline-block',
                    float: 'right'
                },
            },
            ".menuNotificationPopper": {
                zIndex: 10,
            },
            ".menuNotificationButton": {
                marginRight: 10
            },
            ".filterAdvanceOptions": {
                border: "2px solid #1751a1",
                backgroundColor: "#f9f9f9",
                "& .MuiPaper-root": {
                    margin: 0
                },
                "& .filterAdvanceInputs": {
                    paddingRight: 90
                },
                "& .filterAdvanceButtonApply": {
                    display: 'flex',
                    justifyContent: 'center',
                    border: '2px solid #bdbdbd',
                    backgroundColor: 'white',
                    borderRadius: '3px',
                    margin: '5px 8px'
                }
            },
            ".buttonDeleteAllChips": {
                marginTop: 8
            },
            ".selectedChips": {
                margin: theme.spacing(0.5),
            },
            ".ProductsContainerFacturacion": {
                "& .tableOptions": {
                    marginTop: 0
                }
            },
            ".modalDetail": {
                "& .MuiGrid-item > span": {
                    overflowWrap: "anywhere"
                }
            },
            ".banners-fields": {
                "& .field-label": {
                    fontFamily: "Montserrat, serif",
                    fontWeight: 500,
                    fontSize: 14
                },

                "& .image-container": {
                    position: "relative",
                    marginTop: 8,

                    "&:hover": {
                        "& .MuiIconButton-root": {
                            display: "inline-flex"
                        }
                    },

                    "& .MuiIconButton-root": {
                        display: "none",
                        position: "absolute",
                        top: 0,
                        right: 0
                    },

                    "& img": {
                        maxWidth: "100%"
                    }
                },
            },
            ".headers-fields": {
                "& .field-label": {
                    fontFamily: "Montserrat, serif",
                    marginBottom: 5,

                    "&.MuiTypography-body1": {
                        fontWeight: 500,
                        fontSize: 14,
                        color: "#737373",
                        marginBottom: 0
                    }
                },

                "& .row": {
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 5,

                    "& .MuiButton-root": {
                        marginLeft: 15
                    }
                },

                "& .error": {
                    color: "#f44336"
                },

                "& .delete": {
                    position: "absolute",
                    right: 15,
                    top: 4,
                    zIndex: 10
                },

                "& .MuiLink-root": {
                    marginBottom: 3
                },

                "& .submenu-container": {
                    padding: 15,
                    boxShadow: "0px 2px 10px -1px rgba(0, 0, 0, 0.2)"
                },

                "& .disabled-input fieldset": {
                    backgroundColor: "#8080801a"
                },

                "& .collapsable-section": {
                    boxShadow: "none",

                    "& > .MuiAccordionSummary-root": {
                        paddingLeft: 0,

                        "& .MuiAccordionSummary-content": {
                            margin: 0
                        },

                        "& .MuiAccordionSummary-expandIcon .MuiSvgIcon-root": {
                            fontSize: "2.5rem",
                            color: "#1751a1"
                        }
                    },

                    "& .MuiAccordionDetails-root": {
                        padding: 0
                    }
                }
            },
            ".footers-fields": {
                "& .field-label": {
                    fontFamily: "Montserrat, serif",
                    marginBottom: 5,

                    "&.MuiTypography-body1": {
                        fontWeight: 500,
                        fontSize: 14,
                        color: "#737373",
                        marginBottom: 0
                    }
                },

                "& .logo-container img": {
                    maxHeight: 50
                },

                "& .network-container": {
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",

                    "& .MuiLink-root": {
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    },

                    "& img": {
                        maxWidth: 35
                    }
                },

                "& .product-container": {
                    position: "relative",

                    "& .MuiLink-root": {
                        marginBottom: 5
                    },

                    "& .MuiDivider-root": {
                        marginBottom: 16,
                        marginTop: 8
                    },

                    "& > .MuiGrid-container": {
                        marginTop: -4
                    },

                    "& .delete": {
                        right: 5,
                        top: -4
                    }
                },

                "& .legal-links-container img": {
                    maxWidth: 150
                },

                "& .row": {
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 5,

                    "& .MuiButton-root": {
                        marginLeft: 15
                    }
                },

                "& img": {
                    backgroundColor: "#1751a1",
                    padding: 5
                },

                "& .error": {
                    color: "#f44336"
                },

                "& .delete": {
                    position: "absolute",
                    right: 15,
                    top: 4,
                    zIndex: 10
                },

                "& .MuiLink-root": {
                    marginBottom: 3
                },

                "& .collapsable-section": {
                    boxShadow: "none",

                    "& > .MuiAccordionSummary-root": {
                        paddingLeft: 0,

                        "& .MuiAccordionSummary-content": {
                            margin: 0
                        },

                        "& .MuiAccordionSummary-expandIcon .MuiSvgIcon-root": {
                            fontSize: "2.5rem",
                            color: "#1751a1"
                        }
                    },

                    "& .MuiAccordionDetails-root": {
                        padding: 0,
                        flexDirection: "column"
                    }
                }
            },
            ".refund-tabs": {
                '& .MuiTab-root': {
                    boxShadow: '1px 5px 10px rgba(0, 0, 0, 0.5)',

                    '&:not(.Mui-selected)': {
                        boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.5)',
                    },
                }
            },
            ".home-comments-fields": {
                "& .field-label": {
                    fontFamily: "Montserrat, serif",
                    marginBottom: 5,

                    "&.MuiTypography-body1": {
                        fontWeight: 500,
                        fontSize: 14,
                        color: "#737373",
                        marginBottom: 0
                    }
                },

                "& .product-container": {
                    position: "relative",

                    "& .MuiDivider-root": {
                        marginBottom: 16,
                        marginTop: 8
                    },

                    "& > .MuiGrid-container": {
                        marginTop: -4
                    },

                    "& .delete": {
                        right: 5,
                        top: -4
                    }
                },

                "& .row": {
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 5,

                    "& .MuiButton-root": {
                        marginLeft: 15
                    }
                },

                "& .error": {
                    color: "#f44336"
                },

                "& .delete": {
                    position: "absolute",
                    right: 15,
                    top: 4,
                    zIndex: 10
                }
            },
            ".home-coverages-fields": {
                "& .field-label": {
                    fontFamily: "Montserrat, serif",
                    marginBottom: 5,

                    "&.MuiTypography-body1": {
                        fontWeight: 500,
                        fontSize: 14,
                        color: "#737373",
                        marginBottom: 0
                    }
                },

                "& .product-container": {
                    position: "relative",

                    "& .MuiDivider-root": {
                        marginBottom: 16,
                        marginTop: 8
                    },

                    "& > .MuiGrid-container": {
                        marginTop: -4
                    },

                    "& .delete": {
                        right: 5,
                        top: -4
                    }
                },

                "& .row": {
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 5,

                    "& .MuiButton-root": {
                        marginLeft: 15
                    }
                },

                "& .error": {
                    color: "#f44336"
                },

                "& .delete": {
                    position: "absolute",
                    right: 15,
                    top: 4,
                    zIndex: 10
                }
            },
            ".home-differential-services-fields": {
                "& .field-label": {
                    fontFamily: "Montserrat, serif",
                    marginBottom: 5,

                    "&.MuiTypography-body1": {
                        fontWeight: 500,
                        fontSize: 14,
                        color: "#737373",
                        marginBottom: 0
                    }
                },

                "& .product-container": {
                    position: "relative",

                    "& .MuiDivider-root": {
                        marginBottom: 16,
                        marginTop: 8
                    },

                    "& > .MuiGrid-container": {
                        marginTop: -4
                    },

                    "& .delete": {
                        right: 5,
                        top: -4
                    }
                },

                "& .row": {
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 5,

                    "& .MuiButton-root": {
                        marginLeft: 15
                    }
                },

                "& .error": {
                    color: "#f44336"
                },

                "& .delete": {
                    position: "absolute",
                    right: 15,
                    top: 4,
                    zIndex: 10
                }
            },
            ".home-why-choose-us-fields": {
                "& .field-label": {
                    fontFamily: "Montserrat, serif",
                    marginBottom: 5,

                    "&.MuiTypography-body1": {
                        fontWeight: 500,
                        fontSize: 14,
                        color: "#737373",
                        marginBottom: 0
                    }
                },

                "& .product-container": {
                    position: "relative",

                    "& .MuiDivider-root": {
                        marginBottom: 16,
                        marginTop: 8
                    },

                    "& > .MuiGrid-container": {
                        marginTop: -4
                    },

                    "& .delete": {
                        right: 5,
                        top: -4
                    }
                },

                "& .row": {
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 5,

                    "& .MuiButton-root": {
                        marginLeft: 15
                    }
                },

                "& .error": {
                    color: "#f44336"
                },

                "& .delete": {
                    position: "absolute",
                    right: 15,
                    top: 4,
                    zIndex: 10
                }
            },
            ".home-product-necessity-fields": {
                "& .field-label": {
                    fontFamily: "Montserrat, serif",
                    marginBottom: 5,

                    "&.MuiTypography-body1": {
                        fontWeight: 500,
                        fontSize: 14,
                        color: "#737373",
                        marginBottom: 0
                    }
                },

                "& .product-container": {
                    position: "relative",

                    "& .MuiDivider-root": {
                        marginBottom: 16,
                        marginTop: 8
                    },

                    "& > .MuiGrid-container": {
                        marginTop: -4
                    },

                    "& .delete": {
                        right: 5,
                        top: -4
                    }
                },

                "& .row": {
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 5,

                    "& .MuiButton-root": {
                        marginLeft: 15
                    }
                },

                "& .error": {
                    color: "#f44336"
                },

                "& .delete": {
                    position: "absolute",
                    right: 15,
                    top: 4,
                    zIndex: 10
                }
            },
            ".home-landing-cities-fields": {
                "& .field-label": {
                    fontFamily: "Montserrat, serif",
                    marginBottom: 5,

                    "&.MuiTypography-body1": {
                        fontWeight: 500,
                        fontSize: 14,
                        color: "#737373",
                        marginBottom: 0
                    }
                },

                "& .product-container": {
                    position: "relative",

                    "& .MuiDivider-root": {
                        marginBottom: 16,
                        marginTop: 8
                    },

                    "& > .MuiGrid-container": {
                        marginTop: -4
                    },

                    "& .delete": {
                        right: 5,
                        top: -4
                    }
                },

                "& .row": {
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 5,

                    "& .MuiButton-root": {
                        marginLeft: 15
                    }
                },

                "& .error": {
                    color: "#f44336"
                },

                "& .delete": {
                    position: "absolute",
                    right: 15,
                    top: 4,
                    zIndex: 10
                },

                "& .submenu-container": {
                    padding: 15,
                    boxShadow: "0px 2px 10px -1px rgba(0, 0, 0, 0.2)"
                },
            },
            ".notifications-fields": {
                "& .field-label": {
                    fontFamily: "Montserrat, serif",
                    marginBottom: 5,

                    "&.MuiTypography-body1": {
                        fontWeight: 500,
                        fontSize: 14,
                        color: "#737373",
                        marginBottom: 0
                    }
                },

                "& .error": {
                    color: "#f44336"
                },
            },
            ".header-preview": {
                minHeight: "110px",
                color: "black !important",
                position: "initial !important",
                padding: "0px !important",
                backgroundColor: `#f8f9fc !important`,

                "& .top": {
                    minHeight: "34px",
                    padding: "2px 0",
                    backgroundColor: "#f8f9fc",
                    justifyContent: "flex-end",
                    alignItems: "center",

                    "& > *": {
                        margin: "5px 15px",
                        display: "flex",
                        alignItems: "center",

                        "& .MuiSvgIcon-root": {
                            marginRight: 5
                        }
                    },

                    "& .admin": {
                        padding: 5,
                        backgroundColor: "#3d8eff",
                        cursor: "pointer"
                    },

                    "& .select-language": {
                        "&:before": {
                            borderBottom: "none"
                        },

                        "& .MuiInputAdornment-root, & .MuiIconButton-root": {
                            padding: 0,
                            margin: 0
                        },

                        "& .MuiSelect-select": {
                            minWidth: 0,
                            paddingRight: 18
                        },

                        "& .MuiSvgIcon-root": {
                            marginRight: 0
                        }
                    },

                    "& .login-container": {
                        padding: 0
                    },

                    "& .top-mobile": {
                        justifyContent: "flex-end",

                        "& > *": {
                            margin: "5px auto",
                            display: "flex",
                            alignItems: "center",
                        },
                    },

                    "& .MuiFormControl-root": {
                        padding: 0
                    }
                },

                "& .top.small": {
                    maxWidth: 400,
                    marginLeft: "auto",

                    "&.is-agency": {
                        maxWidth: "none"
                    },

                    "& > *": {
                        margin: "5px auto"
                    },

                    "& > span": {
                        fontSize: 14
                    },
                },

                "& .top:not(.is-agency)": {
                    "& .small-text": {
                        fontSize: 14,

                        "& .quote": {
                            color: "#1751a1"
                        },
                    },

                    "& .login-container": {
                        color: "#1751a1"
                    }
                },

                "& .top.is-agency": {
                    backgroundColor: "#1751a1",
                    color: "white",

                    "& .small-text": {
                        fontSize: 12
                    },

                    "& .select-language *, & .login-container": {
                        color: "white"
                    }
                },

                "& .bottom": {
                    minHeight: "80px",
                    padding: "0 10px",
                    backgroundColor: "white",
                    alignItems: "center",
                    justifyContent: "space-between",

                    "& .logo": {
                        maxWidth: "50%",
                        cursor: "pointer"
                    },

                    "& .menu-button": {
                        minWidth: "fit-content",
                        padding: "5px 10px",
                        marginLeft: 5,
                        borderColor: "#1976d280",

                        "&:hover": {
                            borderColor: "#1976d2",
                            backgroundColor: "#1975d20a"
                        }
                    },

                    "& .menu": {
                        display: "flex",
                        alignItems: "center",

                        "& .menu-button:first-child": {
                            marginLeft: 0
                        },

                        "& .MuiSvgIcon-root": {
                            color: "#1751a1"
                        },

                        "& .contact-info": {
                            alignItems: "center",
                            width: "fit-content",

                            "& .MuiGrid-item:first-child": {
                                height: 24
                            },

                            "& .phone": {
                                fontSize: 20,
                                color: "#1751a1",
                                lineHeight: 1.5,
                                marginLeft: 5
                            },

                            "& .message": {
                                fontSize: 13,
                                color: styles.colors.gray,
                                marginLeft: 5
                            }
                        }
                    }
                },

                "& .mobile-menu": {
                    marginTop: 0,

                    "& .MuiAccordionDetails-root": {
                        padding: "0 16px",
                        flexDirection: "column",

                        "&> div:not(:first-child)": {
                            borderTop: `1px solid #a6bdee`
                        },

                        "& .list-item-button:hover": {
                            backgroundColor: "#f1f1f1"
                        }
                    }
                },

                "& .menu-icon": {
                    display: "flex",
                    alignItems: "center",
                    height: 20,
                    width: 20,
                    marginRight: 4
                }
            },
            ".footer-preview": {
                backgroundColor: "#1751a1",
                height: "fit-content",
                padding: "40px 10% 20px",
                color: "white",

                "& .icons-container": {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",

                    "&.mobile": {
                        "& img": {
                            margin: "auto"
                        }
                    },

                    "& .MuiSvgIcon-root": {
                        margin: "0 5px",
                        color: "white",
                    }
                },

                "& .list": {
                    justifyContent: "space-between",
                    borderBottom: "1px solid white",
                    padding: "50px 0",
                    marginBottom: 20,

                    "&.mobile": {
                        padding: "10px 0 20px",
                    },

                    "& .item": {
                        display: "flex",
                        flexDirection: "column",
                        maxWidth: 255,
                        margin: "10px 0",

                        "& .title": {
                            marginBottom: 10,
                            fontSize: 18,
                            color: "white",
                        },
                    }
                },

                "& .MuiAccordion-root": {
                    backgroundColor: "#1751a1",
                    margin: 0,

                    "&::before": {
                        display: "none"
                    },

                    "& .MuiAccordionSummary-root": {
                        padding: 0,
                        minHeight: 0,

                        "& .MuiAccordionSummary-content": {
                            margin: "12px 0"
                        }
                    },

                    "&.columns-accordion": {
                        "& .MuiAccordionDetails-root": {
                            display: "flex",
                            flexDirection: "column",
                            padding: 0
                        },

                        "& .title, & .MuiAccordionSummary-expandIcon": {
                            fontSize: 18,
                            color: "white",
                        },
                    }
                },

                "& .accordion-footer": {
                    marginTop: 10,
                    backgroundColor: "#1751a1",

                    "& > .MuiAccordionSummary-root": {
                        minHeight: 35,

                        "& > .MuiAccordionSummary-content": {
                            display: "none"
                        },

                        "& > .MuiAccordionSummary-expandIcon": {
                            color: "white"
                        }
                    },

                    "& .MuiAccordionDetails-root": {
                        display: "block"
                    },
                },

                "& .regret": {
                    justifyContent: "space-between",
                    color: "white",
                    alignItems: "center",

                    "& .MuiGrid-item": {
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",

                        "& .button": {
                            color: "white",
                            border: "1px solid white",
                            marginRight: 10,
                            minWidth: "fit-content"
                        },

                        "& span": {
                            fontSize: 14,
                            margin: "10px 0"
                        }
                    }
                },

                "& .policies": {
                    color: "white",
                    justifyContent: "space-between",
                    marginTop: 20,

                    "& .link": {
                        marginRight: 20
                    },

                    "& .link:last-child": {
                        marginRight: 0,
                        marginLeft: "auto"
                    }
                },

                "& .link": {
                    fontSize: 14,
                    color: "white",
                    marginBottom: 5
                },
            },
            ".comments-preview": {
                padding: "50px 10px",
                textAlign: "center",
                backgroundColor: "#f8f9fc",

                "& .title": {
                    color: "#1751a1",
                    fontSize: 36,
                },

                "& .comments": {
                    marginTop: 30,
                    width: "100%",

                    "& .react-multi-carousel-list": {
                        display: "grid",

                        "& .react-multi-carousel-track": {
                            justifySelf: "center",

                            "& .react-multi-carousel-item": {
                                display: "flex",
                                justifyContent: "center"
                            }
                        },

                        "& .react-multiple-carousel__arrow.hidden": {
                            display: "none"
                        }
                    },

                    "& .opinion-card": {
                        width: 240,
                        textAlign: "left",
                        backgroundColor: "white",
                        borderRadius: 20,
                        padding: 20,
                        margin: "10px",

                        "& p": {
                            height: 200,
                            color: "#1751a1",
                            fontStyle: "italic",
                            fontSize: "14px"
                        },

                        "& .user-info": {
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 10,

                            "& .MuiAvatar-root": {
                                marginRight: 10,
                            },

                            "& .info": {
                                display: "grid",

                                "& span:first-child": {
                                    color: "#1751a1",
                                },

                                "& span:nth-child(2)": {
                                    color: "#3d8eff",
                                    fontSize: "14px"
                                }
                            },

                            "& .star-icon": {
                                color: "#f1471e"
                            }
                        }
                    },
                    ".coverage_includes-preview": {
                        padding: "0 15px",
                        textAlign: "center",

                        "& .title": {
                            color: "#1751a1",
                            fontSize: 36,
                        },

                        "& .list": {
                            marginTop: 30,
                            justifyContent: "center",

                            "& .item": {
                                margin: "10px 20px",
                                width: 100,

                                "@media (min-width: 600px)": {
                                    width: 150,
                                },

                                "& .MuiAvatar-root": {
                                    marginBottom: 20,
                                    width: 100,
                                    height: 100,

                                    "@media (min-width: 600px)": {
                                        width: "150px !important",
                                        height: "150px !important"
                                    },
                                }
                            }
                        }
                    },
                    ".differential-services-preview": {
                        padding: "0 15px",
                        textAlign: "center",

                        "& .title-container": {
                            display: "grid",

                            "& .title": {
                                color: "#1751a1",
                                fontSize: 36,
                            },

                            "& .learn-more": {
                                justifySelf: "end",
                                alignItems: "center",
                                color: "#1751a1",
                                display: "flex"
                            }
                        },

                        "& p": {
                            fontSize: "20px",
                            color: "#425459"
                        },

                        "& .list": {
                            marginTop: 30,
                            justifyContent: "center",

                            "& .item": {
                                margin: "20px",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",

                                "& .MuiAvatar-root": {
                                    height: 250,
                                    width: 250,
                                    marginBottom: 20
                                },

                                "& .info": {
                                    display: "flex",
                                    flexDirection: "column",

                                    "& .item-title": {
                                        color: "#1751a1",
                                        fontWeight: "bold",
                                        fontSize: "30px",
                                        marginBottom: 10,
                                        padding: "0 10px"
                                    },

                                    "& .item-description": {
                                        fontSize: "20px",
                                        padding: "0 15px",
                                        color: "#425459"
                                    },
                                }
                            }
                        }
                    },
                    ".why-choose-us-preview": {
                        padding: "0 15px",
                        textAlign: "center",

                        "& .title-container": {
                            display: "grid",

                            "& .title": {
                                color: "#1751a1",
                                fontSize: 36,
                            },

                            "& .learn-more": {
                                justifySelf: "end",
                                alignItems: "center",
                                color: "#1751a1",
                                display: "flex"
                            }
                        },

                        "& p": {
                            fontSize: "20px",
                            color: "#425459"
                        },

                        "& .list": {
                            marginTop: 30,
                            justifyContent: "center",

                            "& .item": {
                                margin: "10px 20px",
                                width: 200,

                                "& .MuiAvatar-root": {
                                    height: 200,
                                    width: 200,
                                    marginBottom: 20
                                },

                                "& span": {
                                    color: "#1751a1",
                                    fontSize: "20px"
                                }
                            }
                        }
                    },
                    ".products-necessity-preview": {
                        padding: "0 15px",
                        textAlign: "center",

                        "& .title": {
                            color: "#1751a1",
                            fontSize: 36,
                        },

                        "& .list": {
                            marginTop: 30,
                            justifyContent: "center",

                            "& .item": {
                                margin: "10px 20px",
                                width: 400,
                                minHeight: 550,
                                textAlign: "center",
                                paddingBottom: 20,
                                display: "grid",
                                backgroundColor: "#f8f9fc",
                                boxShadow: "3px 3px 5px lightgray",
                                borderRadius: 10,
                                alignContent: "space-between",

                                "& .item-image": {
                                    width: "100%",
                                    borderRadius: "10px 10px 0 0"
                                },

                                "& .item-title": {
                                    color: "#1751a1",
                                    fontWeight: "bold",
                                    fontSize: "18px",
                                    marginBottom: 10,
                                    padding: "0 10px"
                                },

                                "& .item-description": {
                                    fontSize: "16px",
                                    padding: "0 15px",
                                    color: "#425459"
                                },

                                "& .MuiButton-root": {
                                    width: "fit-content",
                                    margin: "auto"
                                }
                            }
                        }
                    },
                    ".landing-cities-preview": {
                        padding: "0 15px",
                        backgroundColor: "white",
                        display: "grid",

                        "& .title-container": {
                            display: "flex",
                            alignItems: "center",
                            justifySelf: "center",

                            "& .world-icon": {
                                color: "#b91410"
                            },

                            "& .title": {
                                color: "#1751a1",
                                fontSize: 36,
                            },
                        },

                        "& .list": {
                            marginTop: 30,
                            justifyContent: "center",

                            "& .item": {
                                margin: "10px 20px",
                                maxWidth: 300,
                                display: "grid",

                                "& .item-image": {
                                    width: "100%",
                                    borderRadius: "10px",
                                    marginBottom: 10
                                },

                                "& .span-gray": {
                                    color: "#58666a"
                                }
                            }
                        }
                    },
                    ".switch-container": {
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 0,
                        marginRight: 10,

                        "&.B2C": {
                            color: "#fc9d0f",
                            "& .MuiSwitch-switchBase": {
                                color: "#fc9d0f",
                            },
                            "& .MuiSwitch-track": {
                                backgroundColor: "#fcc36e",
                                opacity: 0.5
                            }
                        },

                        "&.B2B": {
                            color: "#19a9ff",
                            "& .MuiSwitch-switchBase": {
                                color: "#19a9ff",
                            },
                            "& .MuiSwitch-track": {
                                backgroundColor: "#74cafe"
                            }
                        },

                        "& .MuiTypography-root": {
                            fontWeight: 600,
                            width: 31
                        }
                    },
                    ".country-flag": {
                        marginRight: 5,
                        borderRadius: 5,
                        backgroundColor: "white"
                    },
                    ".list-item-button": {
                        cursor: "pointer"
                    },
                    ".sortable-container .sortable-item:hover": {
                        cursor: 'grab'
                    }
                }
            },
            ".field-modified": {
                "& .MuiInputBase-root, & input": {
                    backgroundColor: "#fff8e1", // amber[50]
                    borderColor: "#ffd54f"      // amber[300]
                }
            },

            ".field-applied": {
                "& .MuiInputBase-root, & input": {
                    backgroundColor: "#e8f5e9", // green[50]
                    borderColor: "#81c784",     // green[300]
                    color: "#2e7d32 !important"
                }
            },

            ".field-error": {
                "& .MuiInputBase-root, & input": {
                    backgroundColor: "#ffebee", // red[50]
                    borderColor: "#e57373"      // red[300]
                }
            },
            ".modify-promotions": {
                "& .MuiTableCell-root": {
                    padding: 6
                },
                "& .MuiOutlinedInput-adornedStart": {
                    paddingLeft: 0
                },
                "& .MuiInputAdornment-positionStart": {
                    marginRight: 0
                },
                "& .MuiIconButton-root": {
                    padding: 6
                }
            }


        }
    })(() => null);

    return <ThemeProvider theme={theme}><GlobalCSS />{children}</ThemeProvider>
};

export default Theme;
